import React from 'react';
import withResize from '../../../../../common/hoc/withResize';

import {
  StyledHrSkeletonRow,
  StyledHrSkeletonWrapper,
  SkeletonWrapper,
  PriceSkeleton,
  ImageSkeleton,
  ButtonSkeleton,
  NameSkeleton,
  ColorChipSkeleton,
  StyledHeading,
  StyledViewAll,
  StyleCategoryHeadingRow,
} from '../../styles/HorizontalCarouselSkeleton.style';

const HorizontalCarouselSkeleton = () => {
  const col = 6;

  return (
    <StyledHrSkeletonWrapper>
      <StyleCategoryHeadingRow>
        <StyledHeading />
        <StyledViewAll />
      </StyleCategoryHeadingRow>
      <StyledHrSkeletonRow>
        {[...Array(col)].map((_val, index) => (
          <>
            <SkeletonWrapper key={index.toString()}>
              <ImageSkeleton />
              <ColorChipSkeleton />
              <PriceSkeleton />
              <NameSkeleton />
              <ButtonSkeleton />
            </SkeletonWrapper>
          </>
        ))}
      </StyledHrSkeletonRow>
    </StyledHrSkeletonWrapper>
  );
};

export default withResize(HorizontalCarouselSkeleton);
